import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import { vehicles } from '../../../../../../redux/vehicles/action';
import VehicleComponent from '../components/vehicle.component';
import { agents } from '../../../../../../redux/agents/action';
import { selectTransportersListItems } from '../../../../../../redux/transporters/selector';
import { selectVehiclesQueryItems } from '../../../../../../redux/vehicles/selector';
import { selectAgentsListItems } from '../../../../../../redux/agents/selector';
import PageLoader from '../../../../../../components/PageLoader';
import { transporters } from '../../../../../../redux/transporters/action';
import { selectListItems } from '../../../../../../redux/library/selector';
import { vehicleCategories } from '../../../../../../redux/vehicle-categories/action';
import { selectVehicleCategoriesListItems } from '../../../../../../redux/vehicle-categories/selector';

const ManagementVehicle = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const libraryData = useSelector(selectListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const vehicleQuery = useSelector(selectVehiclesQueryItems)
  const transportAgentListItems = useSelector(selectAgentsListItems)
  const transporterListItems = useSelector(selectTransportersListItems)
  const vehicleCategoriesListItems = useSelector(selectVehicleCategoriesListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedVehicle,
    setSelectedVehicle
  ] = useState<any>([])

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])

  const fetchVehicleById = () => {
    dispatch(vehicles.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/query`, entity: 'vehicles', jsonData: {

        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }



  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedVehicle({ ...selectedVehicle, [field]: event });
  }




  useEffect(
    () => {
      dispatch(agents.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-agents/list`, entity: 'agents', jsonData: {

        }
      })).then(() => {
        dispatch(transporters.list({
          url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transporters/list`, entity: 'transporters', jsonData: {

          }
        }))
      }).then(() => {
        dispatch(vehicleCategories.list({
          url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/vehicle-categories/list`, entity: 'vehicleCategory', jsonData: {

          }
        }))
      }).then(() => {
        if (parmas?.id > 0) {
          fetchVehicleById()
          setIsLoading(false)
        } else {

          setIsLoading(false)

        }
      })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        const data = vehicleQuery?.result?.items
        const vehicleData = {
          "Id": data?.Id || 0,
          "TransporterId": data?.TransporterId,
          "TransportAgentId": data?.TransportAgentId,
          "LogisticsVehicleCategoryId": data?.LogisticsVehicleCategoryId,
          "VehicleName": data?.VehicleName,
          "VehicleBodyTypeId": data?.VehicleBodyTypeId,
          "RegistrationNumber": data?.RegistrationNumber,
          "VehicleWeight": data?.VehicleWeight,
          "LoadingCapacity": data?.LoadingCapacity,
          "Price": data?.Price,
          "TripVehicleBasePrice": data?.TripVehicleBasePrice,
          "TripDistanceLimit": data?.TripDistanceLimit,
          "Length": data?.VehicleDimension?.length?.value,
          "Width": data?.VehicleDimension?.breadth?.value,
          "Height": data?.VehicleDimension?.height?.value,
          "VehicleDescription": data?.VehicleDescription,
          "MediaMappings": data?.MediaMappings
        }

        setSelectedVehicle(vehicleData)

      }
    },
    [isQuery]
  )


  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value)
  }


  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    const vehicleData = {
      "Id": selectedVehicle?.Id || 0,
      "TransporterId": selectedVehicle?.TransporterId,
      "TransportAgentId": selectedVehicle?.TransportAgentId,
      "VehicleName": selectedVehicle?.VehicleName,
      "RegistrationNumber": selectedVehicle?.RegistrationNumber,
      "VehicleBodyTypeId": selectedVehicle?.VehicleBodyTypeId,
      "VehicleWeight": selectedVehicle?.VehicleWeight,
      "LoadingCapacity": selectedVehicle?.LoadingCapacity,
      "Price": selectedVehicle?.Price,
      "TripVehiclePricePerKm": 0,
      "TripVehicleBasePrice": selectedVehicle?.TripVehicleBasePrice,
      "TripDistanceLimit": selectedVehicle?.TripDistanceLimit,
      "VehicleDescription": selectedVehicle?.VehicleDescription,
      "LogisticsVehicleCategoryId": selectedVehicle?.LogisticsVehicleCategoryId,
      "VehicleDimension": {
        "length": {
          "unit": "meters",
          "value": selectedVehicle?.Length
        },
        "breadth": {
          "unit": "meters",
          "value": selectedVehicle?.Width
        },
        "height": {
          "unit": "meters",
          "value": selectedVehicle?.Height
        }
      },
      "MediaMappings": {
        "MediaFiles": mediaFiles,
        "Templates": []
      },
      "FunctionAttributes": [],
      "EntityAttributes": []
    }


    if (parmas?.id > 0) {
      await dispatch(vehicles.resetAction({ actionType: 'update' }))
      await dispatch(vehicles.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations`, entity: 'vehicles', jsonData: {

          Records: [
            vehicleData
          ]

        }
      })).then(() => {
        back()
      });

    } else {
      await dispatch(vehicles.resetAction({ actionType: 'create' }))
      await dispatch(vehicles.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations`, entity: 'vehicles', jsonData: {

          Records: [
            vehicleData
          ]

        }
      })).then(() => {
        back()
      });
    }
  }

  const back = () => {
    navigate('/management/logistics/transport/vehicle-registations')
  }

  return (
    <>

      {isLoading ? <PageLoader /> :
        <VehicleComponent
          parmas={parmas}
          onFormItemChange={handleFormMediaItemChange}
          handleInnerFormChange={handleInnerFormChange}
          vehicleBodyTypes={libraryData?.result?.VehicleBodyType}
          selectedVehicle={selectedVehicle}
          vehicleCategories={vehicleCategoriesListItems?.result?.items}
          transportAgents={transportAgentListItems?.result?.items}
          transporters={transporterListItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ManagementVehicle;